export enum LOCALES {
    en = "en",
    de = "de",
}

export type ILocales = keyof typeof LOCALES;
